import React from 'react';
import { ChemicalType } from '../types';
import { CHEMICAL_LIST } from '../constants/chemicals';
import { Droplet, Layers, Beaker, ShieldAlert, LayoutGrid } from 'lucide-react';

interface ChemicalSelectorProps {
  selectedChemical: ChemicalType | 'all';
  onSelect: (chem: ChemicalType | 'all') => void;
}

export const ChemicalSelector: React.FC<ChemicalSelectorProps> = ({
  selectedChemical,
  onSelect,
}) => {
  const getIcon = (id: ChemicalType) => {
    switch (id) {
      case 'alum': return <Beaker className="w-4 h-4" />;
      case 'pac': return <Droplet className="w-4 h-4" />;
      case 'chl': return <ShieldAlert className="w-4 h-4" />;
      case 'poly': return <Layers className="w-4 h-4" />;
    }
  };

  return (
    <div className="bg-white rounded-xl p-3 sm:p-4 border border-slate-200 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="text-xs font-semibold uppercase tracking-wider text-slate-400">
          เลือกประเภทสารเคมี (Chemical Type):
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {CHEMICAL_LIST.map((chem) => {
            const isSelected = selectedChemical === chem.id;
            return (
              <button
                key={chem.id}
                type="button"
                onClick={() => onSelect(chem.id)}
                className={`inline-flex items-center gap-2 px-3.5 py-2 text-sm font-semibold rounded-lg border transition-all cursor-pointer ${
                  isSelected
                    ? 'bg-blue-600 text-white border-blue-600 shadow-sm shadow-blue-500/25 ring-2 ring-blue-500/20'
                    : 'bg-slate-50 hover:bg-slate-100 text-slate-700 border-slate-200'
                }`}
              >
                <span className={isSelected ? 'text-white' : 'text-slate-500'}>
                  {getIcon(chem.id)}
                </span>
                <span>{chem.nameEn}</span>
                <span className={`text-xs ${isSelected ? 'text-blue-100' : 'text-slate-400'}`}>
                  ({chem.nameTh})
                </span>
              </button>
            );
          })}

          <div className="h-6 w-px bg-slate-200 mx-1 hidden sm:block" />

          <button
            type="button"
            onClick={() => onSelect('all')}
            className={`inline-flex items-center gap-2 px-3.5 py-2 text-sm font-semibold rounded-lg border transition-all cursor-pointer ${
              selectedChemical === 'all'
                ? 'bg-slate-800 text-white border-slate-800 shadow-sm'
                : 'bg-slate-50 hover:bg-slate-100 text-slate-700 border-slate-200'
            }`}
          >
            <LayoutGrid className="w-4 h-4" />
            <span>ดูสารเคมีทั้งหมด (All)</span>
          </button>
        </div>
      </div>
    </div>
  );
};
